import React from 'react';

import * as BoxC from './_ccbBoxC';
import * as BtnC from './_cccBtnC';
import * as GridC from './_cccGridC';
import * as HdrC from './_ccmHdrC';
import { a } from './_cmABT';
import * as _cr from './_cr';
import * as _csLcl from './_csLcl';
import { useNgnz } from './_csNgn';
import * as _ht from './_ht';
import * as _hm from './_hm';

import * as icm from './icm';
import * as icv from './icv';
import * as icvBaseM10Rz from './icvBaseM10Rz';

const $cz = {
  text: 'その他設定',
};

export const R = (pz: {
}) => {

  const _sNgnz = useNgnz();

  const _sPz = _csLcl.usePz();

  return (
    _cr.c(icvBaseM10Rz.N, {
      boxStlz: a(`fd/csc`),
    }, [

      _cr.c(HdrC.N, {
        key: -10,
        sPz: _sPz,
        abtz: icv.abtz.mainHdrz,
        cz: {
          text: $cz.text
        },
        boxStlz: a(`mb/2`),
      }),

      _cr.c(GridC.N, {
        key: -20,
        abtz: icv.abtz.gridHomez,
        boxStlz: a(`dw/f f/1 fd/cac`),
        lineCs: [
          {
            cellCs: [
              icm.chkPmn(2210) ?
              {
                boxClds: [
                  _cr.c(BtnC.N, {
                    key: -30,
                    abtz: icv.abtz.btnHome2z,
                    lblCz: {
                      text: `地区`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          _sNgnz.setPageName('icvI15M10Rz');
                        }
                      }            
                    },
                  })
                ]
              }
              : undefined,
              icm.chkPmn(2310) ?
              {
                boxClds: [
                  _cr.c(BtnC.N, {
                    key: -50,
                    abtz: icv.abtz.btnHome2z,
                    lblCz: {
                      text: `支払方法`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          _sNgnz.setPageName('icvI18M10Rz');
                        }
                      }            
                    },
                  })
                ]
              }
              : undefined,
              icm.chkPmn(2810) ?
              {
                boxClds: [
                  _cr.c(BtnC.N, {
                    key: -50,
                    abtz: icv.abtz.btnHome2z,
                    lblCz: {
                      text: `店種`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          _sNgnz.setPageName('icvI12M10Rz');
                        }
                      }            
                    },
                  })
                ]
              }
              : undefined,
              icm.chkPmn(2410) ?
              {
                boxClds: [
                  _cr.c(BtnC.N, {
                    key: -50,
                    abtz: icv.abtz.btnHome2z,
                    lblCz: {
                      text: `事業者`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          _sNgnz.setPageName('icvI19M10Rz');
                        }
                      }            
                    },
                  })
                ]
              }
              : undefined,
            ]
          },
          {
            cellCs: [
              icm.chkPmn(2910) ?
              {
                boxClds: [
                  _cr.c(BtnC.N, {
                    key: -60,
                    abtz: icv.abtz.btnHome2z,
                    lblCz: {
                      text: `祝日`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          _sNgnz.setPageName('icv_60M10Rz');
                        }
                      }            
                    },
                  })
                ]
              }
              : undefined,
              icm.chkPmn(2510) ?
              {
                boxClds: [
                  _cr.c(BtnC.N, {
                    key: -60,
                    abtz: icv.abtz.btnHome2z,
                    lblCz: {
                      text: `ユーザー`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          _sNgnz.setPageName('icv_10M10Rz');
                        }
                      }            
                    },
                  })
                ]
              }
              : undefined,
              icm.chkPmn(2610) ?
              {
                boxClds: [
                  _cr.c(BtnC.N, {
                    key: -70,
                    abtz: icv.abtz.btnHome2z,
                    lblCz: {
                      text: `役割`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          _sNgnz.setPageName('icv_41M10Rz');
                        }
                      }            
                    },
                  })
                ]
              }
              : undefined,
              icm.chkPmn(2710) ?
              {
                boxClds: [
                  _cr.c(BtnC.N, {
                    key: -80,
                    abtz: icv.abtz.btnHome2z,
                    lblCz: {
                      text: `役割割当`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          _sNgnz.setPageName('icv_42M10Rz');
                        }
                      }            
                    },
                  })
                ]
              }
              : undefined,
            ]
          }

        ]
      })

    ])

  )
};